<template>
  <div class="mian">
    <div class="landing-1">
      <div class="landing-1-left">
        <img src="../assets/img/wire_logo.jpg" />
      </div>
      <div class="landing-1-right">
        <div class="landing-1-right-logo">
          <img src="../assets/img/20th-anni.png" />
        </div>

        <div class="landing-1-right-titlle">
          The 11th All China – International <br> Wire & Cable Industry Trade Fair<br />wire China 2024
        </div>

        <div class="landing-1-right-date">
          <span class="left-date">2024.9.25 - 28</span> | Shanghai New International Expo Centre
        </div>

        <div class="landing-1-right-btn">
          <a href="http://www.wirechina.net/cn/popularize.aspx?id=1056" target="_blank"><div class="mod-10-1">Booth Application</div></a>
          <a href="http://lp2024-en.wirechina.net" target="_blank"><div class="mod-10-2">About wire China</div></a>
          <a href="http://www.wirechina.net/cn/popularize.aspx?id=1057" target="_blank"><div class="mod-10-3">Visitor Registration</div></a>
          <div class="clear-both"></div>
        </div>

        <div class="landing-2-right-btn">
          <div class="mod-11-1"><span class="iconfont icon-kehu icon-zhanwei"></span>Mr. Alex Gu / Ms. Mary Cao </div>
          <div class="mod-11-2"><span class="iconfont icon-dianhua1 icon-zhanwei"></span>+86 21 6169 8373/8369 </div>
          <div class="mod-11-3"><span class="iconfont icon-youxiang icon-zhanwei"></span>wire@mds.cn</div>
          <div class="clear-both"></div>
        </div>
      </div>
      <div class="clear-both"></div>
    </div>

    <!-- tube -->
    <div class="landing-1">
      <div class="landing-1-left landing-1-left-img">
        <img src="../assets/img/tube_logo.png" />
      </div>
      <div class="landing-1-right tube-bg">
        <div class="landing-1-right-logo">
          <img src="../assets/img/20th-anni.png" />
        </div>

        <div class="landing-1-right-titlle">
          The 11th – International <br> Tube & Pipe Industry Trade Fair<br />Tube China 2024
        </div>

        <div class="landing-1-right-date">
          <span class="left-date">2024.9.25 - 28</span> | Shanghai New International Expo Centre
        </div>

        <div class="landing-1-right-btn">
          <a href="https://www.tubechina.net/links?id=288" target="_blank"><div class="mod-10-1">Booth Application</div></a>
          <a href="http://lp2024-en.tubechina.net" target="_blank"><div class="mod-10-2">About Tube China</div></a>
          <a href="https://www.tubechina.net/links?id=289" target="_blank"><div class="mod-10-3">Visitor Registration</div></a>
          <div class="clear-both"></div>
        </div>

        <div class="landing-2-right-btn">
          <div class="mod-11-1"><span class="iconfont icon-kehu icon-zhanwei"></span>Mr. Sam Xu / Ms. Mary Cao</div>
          <div class="mod-11-2"><span class="iconfont icon-dianhua1 icon-zhanwei"></span>+86 21 6169 8374/8369</div>
          <div class="mod-11-3"><span class="iconfont icon-youxiang icon-zhanwei"></span>tube@mds.cn</div>
          <div class="clear-both"></div>
        </div>
      </div>
      <div class="clear-both"></div>
    </div>

    <div class="padding60"></div>
  </div>
</template>

<script>
  import '../assets/font/iconfont.css';
  import axios from 'axios';
  export default {
    name: 'IndexPage',
    methods: {
      parseQueryString(url) {
        var obj = {}
        var keyvalue = []
        var key = ''
        var value = ''
        var paraString = url.substring(url.indexOf('?') + 1, url.length).split('&')
        for (var i = 0; i < paraString.length; i++) {
          keyvalue = paraString[i].split('=')
          key = keyvalue[0]
          value = keyvalue[1]
          obj[key] = value
        }
        return obj
      },

      postData() {
        const queryString = this.parseQueryString(this.$route.fullPath)
        const params = {
          source: queryString.source,
          url: 'lp2024-navi-en.wirechina.net'
        }
        const res = axios.post('http://wirechina_api.maxdigi.cn/api/log', params)
        res.then(response => {
          console.log('请求成功:')
          console.log('respnse', response)
        })
      }
    },
    mounted() {
      this.postData()
    },
  }
</script>

<style lang="scss" scoped>

  /* 适配手机端，调整字体大小和元素大小等 */
  @media screen and (max-width: 767px) {
    @import '../assets/css/index-mobile.scss'
  }

  /* 适配大屏幕设备（桌面电脑） */
  @media screen and (min-width: 768px) {
    @import '../assets/css/index.scss'
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexPage_en.vue